<template>
    <div class="sidebar">
        <aside class="main-sidebar sidebar-dark-primary elevation-4">
            <a href="/" class="brand-link">
                <img src="/logo.png" alt="Application Logo" class="brand-image img-circle elevation-3">
                <span class="brand-text font-weight-light">{{ $t("label.app_name") }}</span>
            </a>

            <div class="sidebar">
                <div class="user-panel mt-3 pb-3 mb-3 d-flex">
                    <div class="image">
                        <img src="/avatar.png" class="img-circle elevation-2" alt="User Image">
                    </div>
                    <div class="info">
                        <router-link to="/profile" class="d-block" exact >
                            {{user ? user.data.first_name + ' ' + user.data.last_name: ''}}
                        </router-link>
                    </div>
                </div>

                <nav class="mt-2">
                    <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                        <li class="nav-item">
                            <router-link to="/" class="nav-link" exact >
                                <fa :icon="fas.faHome" class="nav-icon"/>
                                <p>{{ $t("label.home") }}</p>
                            </router-link>
                        </li>

                        <template v-if="user && user.data.is_officer">
                            <!-- ! mean show as officer view -->
                            <li class="nav-item has-treeview menu-open">
                                <router-link to="#officer" class="nav-link" exact>
                                    <fa :icon="fas.faFileAlt" class="nav-icon"/>
                                    <p>
                                        {{ $t("label.applications") }}
                                        <fa :icon="fas.faAngleLeft" class="right"/>
                                    </p>
                                </router-link>
                                <ul class="nav nav-treeview">
                                    <li class="nav-item ml-3">
                                        <router-link to="/application/create" class="nav-link" v-if="this.$hasPermission('tempvehicle.application.create')" exact >
                                          <fa :icon="fas.faFile" class="nav-icon"/>
                                          <p> {{ $t("label.create") }}
                                          </p>
                                        </router-link>
                                        <router-link to="/application/search" v-if="this.$hasPermission('tempvehicle.application.view')" class="nav-link" exact>
                                            <fa :icon="fas.faFileAlt" class="nav-icon"/>
                                            <p> {{ $t("label.application") }}
                                            </p>
                                        </router-link>
                                        <!-- <router-link to="/overstay" class="nav-link" exact>-->
                                        <!-- <fa :icon="fas.faClock" class="nav-icon"/>-->
                                        <!-- <p>{{ $t("label.overstay")}}</p>-->
                                        <!-- </router-link>-->
                                        <router-link to="/application/scan" class="nav-link" v-if="this.$hasPermission('tempvehicle.application.view')" exact>
                                            <fa :icon="fas.faQrcode" class="nav-icon"/>
                                            <p> {{ $t("label.scan") }}</p>
                                        </router-link>
                                        <router-link to="/backend/report" class="nav-link" v-if="this.$hasPermission('tempvehicle.application.view')" exact>
                                            <fa :icon="fas.faFileInvoice" class="nav-icon"/>
                                            <p>{{ $t("label.report") }}
                                            </p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item has-treeview">
                                <router-link to="#setting" class="nav-link" exact>
                                    <fa :icon="fas.faCog" class="nav-icon"/>
                                    <p>
                                        {{ $t("label.setting") }}
                                        <fa :icon="fas.faAngleLeft" class="right"/>
                                    </p>
                                </router-link>
                                <ul class="nav nav-treeview">
                                    <li class="nav-item ml-3">
                                        <router-link to="/backend/owner" v-if="this.$hasPermission('tempvehicle.owner.view')" class="nav-link" exact >
                                            <fa :icon="fas.faUsers" class="nav-icon"/>
                                            <p>{{ $t("label.owner") }}
                                            </p>
                                        </router-link>
                                        <router-link to="/backend/driver" v-if="this.$hasPermission('tempvehicle.driver.view')" class="nav-link" exact >
                                            <fa :icon="fas.faUsers" class="nav-icon"/>
                                            <p>{{ $t("label.driver") }}
                                            </p>
                                        </router-link>
                                        <router-link to="/backend/vehicle" v-if="this.$hasPermission('tempvehicle.vehicle.view')" class="nav-link" exact >
                                            <fa :icon="fas.faCar" class="nav-icon"/>
                                            <p>{{ $t("label.vehicle") }}
                                            </p>
                                        </router-link>
                                        <router-link to="/backend/vehicle-type" v-if="this.$hasPermission('tempvehicle.vehicle_type.view')" class="nav-link" exact >
                                            <fa :icon="fas.faTruck" class="nav-icon"/>
                                            <p>
                                                {{ $t("label.vehicle_type") }}
                                            </p>
                                        </router-link>
                                        <router-link to="/backend/fraud" v-if="this.$hasPermission('tempvehicle.fraud.view')" class="nav-link" exact >
                                            <fa :icon="fas.faBan" class="nav-icon"/>
                                            <p>
                                                {{$t("label.fraud") }}
                                            </p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>

                        </template>

                        <template v-else>
                            <li class="nav-item">
                                <router-link to="/profile" class="nav-link" exact >
                                    <fa :icon="fas.faUser" class="nav-icon"/>
                                    <p>{{ $t("label.my_profile") }}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="this.$hasPermission('tempvehicle.application.create')">
                                <router-link to="/application/create" class="nav-link" exact >
                                    <fa :icon="fas.faFile" class="nav-icon"/>
                                    <p>
                                        {{ $t("label.create") }}
                                    </p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="this.$hasPermission('tempvehicle.application.view')">
                                <router-link to="/application" class="nav-link" exact >
                                    <fa :icon="fas.faSearch" class="nav-icon"/>
                                    <p>
                                        {{ $t("label.search") }}
                                    </p>
                                </router-link>
                            </li>
                            <!--
                            <li class="nav-item" v-if="this.$hasPermission('tempvehicle.owner.view')">
                              <router-link :to="{ name: 'Owner'}" class="nav-link" exact >
                                <fa :icon="fas.faUsers" class="nav-icon"/>
                                <p>{{ $t("label.owner") }}</p>
                              </router-link>
                            </li>
                            -->
                            <li class="nav-item" v-if="this.$hasPermission('tempvehicle.vehicle.view')">
                                <router-link to="/vehicle" class="nav-link" exact >
                                    <fa :icon="fas.faCar" class="nav-icon"/>
                                    <p>{{ $t("label.vehicle") }}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="this.$hasPermission('tempvehicle.driver.view')">
                                <router-link to="/driver" class="nav-link" exact >
                                    <fa :icon="fas.faUsers" class="nav-icon"/>
                                    <p>{{ $t("label.driver")}}</p>
                                </router-link>
                            </li>
                        </template>

                        <template v-if="user && user.data.is_officer">
                          <li class="nav-item">
                            <router-link to="/telegram" class="nav-link" exact >
                              <fa :icon="fas.faPaperPlane" class="nav-icon"/>
                              <p>{{ $t("label.telegram") }}</p>
                            </router-link>
                          </li>
                        </template>
                    </ul>
                </nav>
            </div>
        </aside>
    </div>
</template>
<style scope>
    .nav-item > .router-link-exact-active{
        background-color: #666;
        color: white;
    }
</style>

<script>
    import { fas } from "@fortawesome/free-solid-svg-icons";
    import { mapState } from "vuex";
    export default {
        name: "Sidebar",
        computed: {
            fas() {
                return fas;
            },
            ...mapState("user", ["user"])
        },
        updated(){

            // $('.has-treeview > a').removeClass('router-link-exact-active');
            // $('.has-treeview > a').removeClass('router-link-active');
        },
        mounted(){
            // $('.nav-item .has-treeview').on('click', function(){
            // $('.nav-item .has-treeview').removeClass('menu-open');
            //
            // });
        },
        methods: {
            closeSideBar() {
                // $("#sidebar-overlay").trigger("click");
            }
        }
    };
</script>
